module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['widget', 'dof-tag-page-container', _vm.hasMargin && 'slider-margin']
  }, [_c('slider', {
    staticClass: ["dof-tag-page-container-slider"],
    attrs: {
      "infinite": _vm.infinite,
      "scrollable": _vm.scrollable,
      "index": _vm.sliderIndex
    },
    on: {
      "change": _vm.sliderChange
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-0399fa54!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tab-page-container/index.vue
// module id = 559
// module chunks = 0 1